<form
  [formGroup]="emailInputFormGroup"
  [ngClass]="{
    'has-error':
      (emailInputFormGroup.controls['input'].invalid && submitted) ||
      emailInputFormGroup.controls['input'].hasError('required') ||
      emailInputFormGroup.controls['input'].hasError('duplicateEmail') ||
      emailInputFormGroup.controls['input'].hasError('invalidEmail'),
  }"
>
  @if (
    !(
      (emailInputFormGroup.controls['input'].invalid && submitted) ||
      emailInputFormGroup.controls['input'].hasError('required') ||
      emailInputFormGroup.controls['input'].hasError('duplicateEmail') ||
      emailInputFormGroup.controls['input'].hasError('invalidEmail')
    )
  ) {
    <label> Recipients </label>
  }
  @if (emailInputFormGroup.controls['input'].hasError('email') && submitted) {
    <label class="gap-0.5">
      <ion-icon name="alert-circle" class="size-4"></ion-icon>
      Recipients contains an invalid email address
    </label>
  }
  @if (emailInputFormGroup.controls['input'].hasError('required')) {
    <label class="gap-0.5">
      <ion-icon name="alert-circle" class="size-4"></ion-icon>
      Recipients are required
    </label>
  }
  @if (emailInputFormGroup.controls['input'].hasError('duplicateEmail') && submitted) {
    <label class="gap-0.5">
      <ion-icon name="alert-circle" class="size-4"></ion-icon>
      This email address is already added
    </label>
  }
  @if (emailInputFormGroup.controls['input'].hasError('invalidEmail') && submitted) {
    <label class="gap-0.5">
      <ion-icon name="alert-circle" class="size-4"></ion-icon>
      This email address is not allowed
    </label>
  }

  <div
    class="flex flex-row justify-start flex-wrap gap-1 items-start border shadow rounded relative p-2"
    [ngClass]="{
      'border-bright-crimson':
        (emailInputFormGroup.controls['input'].invalid && submitted) ||
        emailInputFormGroup.controls['input'].hasError('required') ||
        emailInputFormGroup.controls['input'].hasError('duplicateEmail') ||
        emailInputFormGroup.controls['input'].hasError('invalidEmail'),
      'border-grey-concrete': !(
        (emailInputFormGroup.controls['input'].invalid && submitted) ||
        emailInputFormGroup.controls['input'].hasError('required') ||
        emailInputFormGroup.controls['input'].hasError('duplicateEmail') ||
        emailInputFormGroup.controls['input'].hasError('invalidEmail')
      ),
    }"
  >
    @for (email of emails; track email; let emailCount = $index) {
      <ion-chip mode="md" class="bg-grey-concrete/75 text-grey-blue font-normal m-0 h-8 px-2.5 text-xs">
        @if (email == customerEmail) {
          <div
            class="size-6 rounded-full flex justify-center -ml-1.5 mr-1 items-center bg-secondary relative z-10 peer shadow hover:scale-110 transition hover:shadow-md"
            tooltip="Primary Email"
          >
            <ion-icon name="person" class="text-white m-0! text-sm"></ion-icon>
          </div>
        }
        @if (email == partnerEmail || email == parentPrimaryEmail) {
          <div
            class="size-6 rounded-full flex justify-center -ml-1.5 mr-1 items-center bg-primary shadow peer peer-odd:-ml-3 relative hover:z-20 hover:scale-110 transition hover:shadow-md"
            tooltip="Reseller Email"
          >
            <ion-icon name="briefcase" class="text-white m-0! text-sm"></ion-icon>
          </div>
        }
        @if (email == accountsEmail) {
          <div
            class="size-6 rounded-full flex justify-center -ml-1.5 mr-1 items-center bg-blue-muted-standard shadow peer peer-odd:-ml-3 relative hover:z-20 hover:scale-110 transition hover:shadow-md"
            tooltip="Accounts Email"
          >
            <ion-icon name="wallet" class="text-white m-0! size-4"></ion-icon>
          </div>
        }
        <ion-label>{{ email }}</ion-label>
        <ion-icon
          name="close-circle"
          class="transition-all hover:text-bright-crimson"
          (click)="removeEmail(emailCount)"
        ></ion-icon>
      </ion-chip>
    }

    <input
      formControlName="input"
      (keydown)="addEmail($event)"
      [placeholder]="emailCount > 0 ? 'Add additional recipients' : 'Add an email address'"
      (blur)="checkValidators()"
      [ngClass]="{
        'text-bright-crimson': emailInputFormGroup.controls['input'].invalid && submitted,
      }"
      type="email"
      autofocus
      class="border-0 shadow-none ring-0 active:ring-0 focus:ring-white focus:ring-0 focus:border-0 inline-flex w-full h-8 text-base transition-none"
      #input
      data-1p-ignore
    />
  </div>
</form>
